export default {
    succText: 'Heel goed.',
    finishButton: 'Sluiten',
    succSubText:
        'U heeft deze cursus met succes afgerond. Zodra u alle lessen van een contactpunt heeft doorlopen, kunt u de eindtoets maken.',
    noPoints: 'U hebt de cursus al een keer voltooid, dus er zijn geen nieuwe punten.'
}
